import { OnInit, Component } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { User } from "@app/data/user";
import { Router } from "@angular/router";
import { ToastService } from "@app/services/toast.service";

@Component({
  templateUrl: "./welcome.component.html",
  animations: [],
})
export class WelcomeComponent implements OnInit {
  user: User;
  answers: {
    contact_email: string;
    name: string;
    job_title: string;
    software_purpose: string[];
    software_purpose_other: string;
    digital_printable: string[];
    how_hear_about_us: string;
    how_hear_about_us_other: string;
    how_hear_about_us_ai_tool: string;
  } = {
    contact_email: "",
    name: "",
    job_title: "",
    software_purpose: [],
    software_purpose_other: "",
    digital_printable: [],
    how_hear_about_us: "",
    how_hear_about_us_other: "",
    how_hear_about_us_ai_tool: "",
  };
  softwarePurposes: { key: string; name: string }[] = [
    { key: "Retail", name: $localize`Retail` },
    { key: "Wholesale", name: $localize`Wholesale` },
    { key: "Inventory", name: $localize`Inventory` },
  ];
  digitalPrintables: { key: string; name: string }[] = [
    { key: "Digital", name: $localize`Digital / Online` },
    { key: "Printable", name: $localize`Printable (PDF)` },
  ];
  howHearAboutUsOptions: { key: string; name: string }[] = [
    { key: "Google", name: $localize`Google search` },
    { key: "ShopifyAppStore", name: $localize`Shopify App Store` },
    { key: "SocialMedia", name: $localize`Social media` },
    { key: "Friend", name: $localize`Friend or colleague` },
    { key: "BlogOrArticle", name: $localize`Blog or article` },
    { key: "YouTube", name: $localize`YouTube` },
    { key: "AIChatbot", name: $localize`AI chatbot (ChatGPT, Claude, Gemini, …)` },
    { key: "Other", name: $localize`Other` },
  ];
  loading: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private toastService: ToastService
  ) {}

  async ngOnInit(): Promise<void> {
    this.user = await this.userService.me();
  }

  get isValid(): boolean {
    return (
      this.answers.contact_email?.trim().length > 0 &&
      this.answers.software_purpose.length > 0 &&
      this.answers.digital_printable.length > 0
    );
  }

  async surveyCompleted() {
    if (!this.isValid) return;
    this.loading = true;
    this.user.business_information = this.answers;
    await this.userService.update(this.user);
    await this.userService.updateContactEmail(
      this.user.business_information.contact_email
    );
    this.loading = false;
    this.router.navigateByUrl("/");
    this.toastService.success($localize`Thank you!`);
  }

  async skip() {
    this.loading = true;
    this.user.business_information = {
      contact_email: "",
      team_size: "",
      deadline: "",
    };
    await this.userService.update(this.user);
    this.loading = false;
    this.router.navigateByUrl("/");
    this.toastService.success($localize`Thank you!`);
  }
}
